import { render, staticRenderFns } from "./TransferSquadView.vue?vue&type=template&id=ae3550ec&scoped=true&"
import script from "./TransferSquadView.vue?vue&type=script&lang=js&"
export * from "./TransferSquadView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3550ec",
  null
  
)

export default component.exports